export default __webpack_public_path__ + "static/media/ogun_state.7561a524.jpg";